import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { getLandingPath } from './access';

export const UserTypeRoute = ({ element, allowedTypes = [] }) => {
  const userType = useSelector((state) => state.user.userType);

  if (userType && !allowedTypes.includes(userType)) {
    return <Navigate to={getLandingPath(userType)} replace />;
  }

  return element;
};
